// extracted by mini-css-extract-plugin
export default {"statistics-card__container":"StatisticsCard_statistics-card__container__NfaSu","statistics-card__body":"StatisticsCard_statistics-card__body__ZmN8U"};